module.exports = __webpack_public_path__ + "static/rgbnoise-7c756fce1f89f24b100bd4f08b36383d.png";